import {
  DynamicFormInputType,
  FormInputTypes,
} from '@components/_old/dynamicForm';

export const EXPORT_FILE_NAME = 'Vignette Ranges';

export const ALL_OPTION = 'ALL';

export const MULTI_CHOICE_FIELDS = ['agency', 'rangeYear', 'rangeStatus'];

/** Numeric-looking keys are always enumerated first by JS objects, which would push "All" to the end. */
export const YEAR_KEY_PREFIX = 'Y';

const withAllOption = (options: Record<string, string> = {}) => ({
  [ALL_OPTION]: 'All',
  ...options,
});

export const getInputs = (
  lovs: Record<string, Record<string, string>>
): Record<string, DynamicFormInputType> => ({
  agency: {
    name: 'agency',
    title: 'Business Partner',
    placeholder: 'Business Partner',
    type: FormInputTypes.chips,
    value: [ALL_OPTION],
    selectOptions: withAllOption(lovs.agency),
    required: false,
    multiple: true,
    showSelectAll: true,
    showSelectAllBelow: true,
  },
  rangeYear: {
    name: 'rangeYear',
    title: 'Year',
    placeholder: 'Year',
    type: FormInputTypes.chips,
    value: [ALL_OPTION],
    selectOptions: withAllOption(lovs.rangeYear),
    required: false,
    multiple: true,
    showSelectAll: true,
    showSelectAllBelow: true,
  },
  rangeStatus: {
    name: 'rangeStatus',
    title: 'Status',
    placeholder: 'Status',
    type: FormInputTypes.chips,
    value: [ALL_OPTION],
    selectOptions: withAllOption(lovs.rangeStatus),
    required: false,
    multiple: true,
    showSelectAll: true,
    showSelectAllBelow: true,
  },
});

const textColumn = (label: string) => ({
  label,
  visible: true,
  isDate: false,
  isCurrency: false,
});

export const excelHeaders = {
  businessPartner: textColumn('Business Partner'),
  rangeYear: textColumn('Vignette Range Year'),
  rangeCode: textColumn('Vignette Range Code'),
  rangeFrom: textColumn('Vignette Range From'),
  rangeTo: textColumn('Vignette Range To'),
  rangeStatus: textColumn('Vignette Range Status'),
};
